import styled from 'styled-components';
import { CustomColors, mobile, STYLE } from '../../styles/variables';
import { boardConfig } from '../../config/boardConfig';

export const IEPlaceholder = styled.div`
    width: 100%;
    height: 100%;
    background: black;
`;

export const Wrapper = styled.div<{ useFullHeight?: boolean; navbarHeight?: string }>`
    height: 100%;
    width: 100%;
    max-width: ${boardConfig.debug ? '100%' : STYLE.page.maxWidth};
    left: ${boardConfig.debug ? 0 : 'unset'};
    position: fixed;
    margin-top: -10px;
    z-index: ${boardConfig.debug ? 99999 : -1};

    ${IEPlaceholder} {
        height: ${({ useFullHeight, navbarHeight }) =>
            useFullHeight ? `100vh` : `calc(100vh - (1.75 * ${navbarHeight} + 28px))`};
    }
`;

export const Placeholder = styled.div<{ show?: boolean }>`
    transition: opacity 0.25s ease-in-out;
    opacity: ${({ show }) => (show ? 1 : 0)};
    max-width: ${STYLE.page.maxWidth};
    background-color: ${CustomColors.tertiary};
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    color: white;
    display: flex;
    align-items: center;
    font-size: 2rem;
    justify-content: center;
    text-transform: uppercase;

    @media ${mobile} {
        left: 0;
    }
`;
